import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AnalyticsService, NgxBarGroup } from '../../services/api';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-pp2-vocab-quiz-report',
  templateUrl: './pp2-vocab-quiz-report.component.html',
  styleUrls: ['./pp2-vocab-quiz-report.component.scss'],
  standalone: false
})
export class Pp2VocabQuizReportComponent implements OnInit, OnChanges {
  @Input() viewsize: [number, number] = [900, 520];
  @Input() disableResize: boolean = false;
  // Date range accepted for API parity (backend endpoint currently has no date filter)
  @Input() startDate?: Date | null;
  @Input() endDate?: Date | null;

  showXAxis = true;
  showYAxis = true;
  showLegend = true; // two stacks: Correct, Incorrect
  showXAxisLabel = true;
  showYAxisLabel = true;
  xAxisLabel = 'Question';
  yAxisLabel = 'Responses';

  chartData: NgxBarGroup[] = [];
  loading = false;
  errorMsg = '';

  colorScheme: Color = {
    name: 'correctIncorrect',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#95c429', '#e85c25']
  };

  // Explicit mapping by series name for deterministic colors
  customColors = [
    { name: 'Correct', value: '#95c429' },
    { name: 'Incorrect', value: '#e85c25' }
  ];

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startDate'] || changes['endDate']) {
      // Backend is GET without date filters; keep behavior consistent
      this.fetchData();
    }
  }

  private fetchData(): void {
    this.loading = true;
    this.errorMsg = '';
    const body = {
      startDateUtc: this.startDate ? this.startDate.toISOString() : undefined,
      endDateUtc: this.endDate ? this.endDate.toISOString() : undefined
    };
    this.analyticsService.analyticsGetPP2VocabularyResponsesByQuestionPost(body).subscribe({
      next: data => {
        this.chartData = (data ?? []).map(g => ({
          name: g.name,
          series: g.series ?? []
        }));
        this.loading = false;
        if (this.disableResize) {
          setTimeout(() => {
            this.viewsize = [this.viewsize[0], this.viewsize[1]];
          });
        }
      },
      error: err => {
        console.error(err);
        this.errorMsg = 'Failed to load data.';
        this.loading = false;
      }
    });
  }

  formatQuestionLabel = (q: string) => {
    if (!q) return '';
    const max = 14;
    const trimmed = q.trim();
    return trimmed.length > max ? trimmed.slice(0, max - 1) + '…' : trimmed;
  };

  onResize(event: any) {
  if (this.disableResize) return;
  const w = event?.target?.innerWidth ?? 1200;
  this.viewsize = [Math.max(680, Math.floor(w * 0.7)), 520];
  }
}
